import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "how-to-arrive my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = { class: "row g-3" };
const _hoisted_4 = { class: "col-12 col-md-6" };
const _hoisted_5 = { class: "list-unstyled m-0" };
const _hoisted_6 = { class: "col-12 col-md-6" };
const _hoisted_7 = { class: "list-unstyled m-0" };
const _hoisted_8 = ["href"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HowToArriveSection',
    props: {
        latitude: {},
        longitude: {},
        address: {},
        transport: {},
        pointsOfInterest: {}
    },
    setup(__props) {
        const props = __props;
        const lat = computed(() => props.latitude ? parseFloat(String(props.latitude)) : null);
        const lng = computed(() => props.longitude ? parseFloat(String(props.longitude)) : null);
        const mapsUrl = computed(() => {
            if (lat.value != null && lng.value != null) {
                return `https://www.google.com/maps?q=${lat.value},${lng.value}`;
            }
            if (props.address) {
                return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(props.address)}`;
            }
            return 'https://www.google.com/maps';
        });
        const transport = computed(() => props.transport || ['Taxi desde el aeropuerto', 'Bus urbano cercano', 'Transporte privado disponible']);
        const pointsOfInterest = computed(() => props.pointsOfInterest || []);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                        _createElementVNode("i", { class: "fas fa-route me-2" }),
                        _createTextVNode("Cómo llegar")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("ul", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transport.value, (item, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "mb-2",
                                        key: i
                                    }, [
                                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-bus me-2 text-primary" }, null, -1)),
                                        _createTextVNode(_toDisplayString(item), 1)
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("ul", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pointsOfInterest.value, (p, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "mb-2",
                                        key: i
                                    }, [
                                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-map-marker-alt me-2 text-primary" }, null, -1)),
                                        _createTextVNode(_toDisplayString(p.name) + " — " + _toDisplayString(p.distanceKm) + " km ", 1)
                                    ]));
                                }), 128))
                            ]),
                            _createElementVNode("a", {
                                href: mapsUrl.value,
                                target: "_blank",
                                rel: "noopener",
                                class: "btn btn-sm btn-outline-primary mt-2"
                            }, " Abrir en Google Maps ", 8, _hoisted_8)
                        ])
                    ])
                ])
            ]));
        };
    }
});
